<template>
  <div class="app-container">
    <Navbar />
    <div class="content-container">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/common/Navbar.vue'
import Footer from '@/components/common/Footer.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style scoped>
@import '@/styles/layouts/defaultLayout.css';
</style>
